import { render, staticRenderFns } from "./CobrancaCadastroModal.vue?vue&type=template&id=4c844445&scoped=true"
import script from "./CobrancaCadastroModal.vue?vue&type=script&lang=js"
export * from "./CobrancaCadastroModal.vue?vue&type=script&lang=js"
import style0 from "./CobrancaCadastroModal.vue?vue&type=style&index=0&id=4c844445&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c844445",
  null
  
)

export default component.exports